<!-- add condition later -->
<div class="new-dataset-container" [formGroup]="form">
  <ng-container *ngIf="mode === 'full'">

  <div class="new-dataset-header">
    <wm-common-text
      [data]="{
        text: 'New Data Set'
      }"
    ></wm-common-text>
  </div>
  <wm-common-text
    [data]="{
      text: `A Data Set allows you to combine data entities from multiple workflows
        into a list of columns that you define. Once created and published, you
        can export this Data Set with appropriate filters. If you map multiple
        data entities from a workflow into a column, those values will be
        concatenated with a comma.`
    }"
  ></wm-common-text>
  <div class="new-dataset-content">
    @for (item of newDatasetContent; track item) {
      <div class="new-dataset-sub-content">
        <wm-common-text
          [data]="{
            text: item
          }"
        ></wm-common-text>
      </div>
    }
  </div>
  <div class="new-dataset-text-footer">
    <wm-common-text
      [data]="{
        text: 'To view more details about this feature, please see our User Guide.'
      }"
    ></wm-common-text>
  </div>
  </ng-container>
  <mat-card class="dataset-card" [class.overlay-disabled]="overlayDisabled" *ngIf="mode === 'full' || mode === 'card'">
    <div class="card-title" *ngIf="mode === 'full'">
      Data Set Information
    </div>
    <div class="dataset-card-body">
      <div class="form-row" *ngIf="mode === 'full' || mode === 'card'">
        <div class="textfield-width field">
          <wm-common-textfield
            formControlName="dataSetName"
            [data]="{
              label: 'Name',
              required: 'true'
            }"
          ></wm-common-textfield>
          @if (form.controls['dataSetName']?.touched && form.controls['dataSetName']?.errors?.['required']) {
            <div class="error-text">
              Name field is required
            </div>
          }
        </div>
        <div class="textfield-width field">
          <wm-common-textfield
            formControlName="dataSetDesc"
            [data]="{
              label: 'Description'
            }"
          ></wm-common-textfield>
        </div>
      </div>
    </div>
  </mat-card>
</div>
